import React from 'react'
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { useDrop } from 'react-dnd'
import classNames from 'classnames';

import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';
import LinkOffIcon from '@material-ui/icons/LinkOff';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Checkbox from '@material-ui/core/Checkbox';

import Tooltip from '@material-ui/core/Tooltip';


const styles = theme => ({
    required:{
        color:'#FF0000',
        fontSize:'75%'
    },
    secondary:{
        color:'rgba(64,186,208,1)'
    },
    secondaryFix:{
        color:'#ff5722'
    },
    listCheck:{
        padding:5
    },
    helpIcon:{
        lineHeight:'24px',
        marginLeft:5,
        verticalAlign:'middle',
        marginTop:-4,
        color:'rgba(0,0,0,0.5)'

    }
});

const DropTarget = ({classes, data, offFunc, checkChangeFunc}) => {
    const [{ canDrop, isOver }, drop] = useDrop({
        accept: 'box',
        drop: () => ({ value: data.value }),
        collect: monitor => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        }),
    });
    const isRelative = (data.relation.length > 0);
    const isChecked = (data.checked !== null && data.checked !== undefined && data.checked !== false);
    const isActive = canDrop && isOver;
    let backgroundColor = isRelative ? 'rgba(64,186,208,0.1)' :
                            isChecked ? 'rgba(255,248,225,0.8)':
                            data.isRequired ? 'rgba(255,205,210,0.3)': '#FFFFFF';

    if (isActive) {
        backgroundColor = isRelative ? 'rgba(64,186,208,0.15)' :
                          isChecked ? 'rgba(255,248,225,0.5)':'rgba(0,0,0,0.05)'
    } else if (canDrop) {
        backgroundColor = isRelative ? 'rgba(64,186,208,0.05)' :
                            isChecked ? 'rgba(255,248,225,0.2)' :'rgba(0,0,0,0.02)'
    }
    const helpIcon = data.captions ? <Tooltip title={data.captions}><i className={classNames("material-icons",classes.helpIcon)}>help_outline</i></Tooltip> : '';
    const primary = data.isRequired && !isRelative && !isChecked ? <span>{data.label}{helpIcon} <small className={classes.required}>※必須</small></span> : <span>{data.label}{helpIcon}</span>;


    const secondary = isRelative ? <span className={classes.secondary}>{data.relation.join(" + ")}</span> :
        isChecked ? <span className={classes.secondaryFix}>固定値</span> : null;


    return (
        <div ref={drop} className={classes.box} style={{backgroundColor}}>
            <ListItem ContainerComponent="div" dense button onClick={checkChangeFunc.bind(this,data)}>
                <ListItemIcon>
                    <Checkbox
                        edge="start"
                        checked={isChecked}
                        tabIndex={-1}
                        disableRipple
                        className={classes.listCheck}
                    />
                </ListItemIcon>
                <ListItemText
                    primary={primary}
                    secondary={secondary}
                />
                {isRelative &&
                <ListItemSecondaryAction>
                    <IconButton edge="end" aria-label="解除" onClick={offFunc.bind(this,data.value)}>
                        <LinkOffIcon />
                    </IconButton>
                </ListItemSecondaryAction>
                }
            </ListItem>
        </div>
    )
};

function mapStateToProps(state) {
    return {
        navigation : state.navigation
    };
}
export default compose(
    withStyles(styles),
    connect(mapStateToProps)
)(DropTarget);


// WEBPACK FOOTER //
// ./src/routes/mapping/step2/components/drop-target.js